export const FIELD_ERRORS = {
  REQUIRED: 'UI-LIB.GENERAL.REQUIRED-ERROR',
  MAXLENGTH: 'UI-LIB.GENERAL.MAX-ERROR',
  MINLENGTH: 'UI-LIB.GENERAL.MIN-ERROR',
  PATTERN: 'UI-LIB.GENERAL.INPUT-VALIDATION-ERROR',
  EMAIL: 'UI-LIB.GENERAL.INPUT-VALIDATION-ERROR',
  NOTFOUND: 'UI-LIB.ERROR-DIALOG.SEARCH.NO-RESULTS-FOUND',
  EMPLOYEE: 'UI-LIB.PROFILE.ERRORS.EMAIL.EMPLOYEE_ERROR',
  CAPTCHA: 'UI-LIB.GENERAL.CAPTCHA-ERROR'
};
